import { Navbar } from "@/components/Navbar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight, BarChart2, Search, Mail } from "lucide-react";

const tools = [
  {
    id: 1,
    title: "SEO Analyzer",
    description: "Analyze your website's SEO performance and get actionable recommendations.",
    icon: Search,
    link: "#"
  },
  {
    id: 2,
    title: "Analytics Dashboard",
    description: "Track and visualize your marketing metrics in real-time.",
    icon: BarChart2,
    link: "#"
  },
  {
    id: 3,
    title: "Email Subject Line Tester",
    description: "Test and optimize your email subject lines for better open rates.",
    icon: Mail,
    link: "#"
  }
];

const Tools = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="py-20 px-4 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-6 text-gray-900">
            Marketing Tools
          </h1>
          <p className="text-xl text-gray-600">
            Free tools to help you analyze and improve your marketing efforts
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {tools.map((tool) => (
            <Card key={tool.id} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="mb-4">
                  <tool.icon className="h-8 w-8 text-primary" />
                </div>
                <CardTitle>{tool.title}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground">
                  {tool.description}
                </p>
                <Button variant="outline" className="w-full group">
                  Try Now
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Tools;